import { createAction } from 'redux-act';


/* Get Employee For Reporting Manager Action */
const getEmployeeForReportingManagerRequest = createAction('GET_EMPLOYEE_FOR_REPORTING_MANAGER_REQUEST', data => data);
const getEmployeeForReportingManagerSuccess = createAction('GET_EMPLOYEE_FOR_REPORTING_MANAGER_SUCCESS', data => data);
const getEmployeeForReportingManagerError = createAction('GET_EMPLOYEE_FOR_REPORTING_MANAGER_ERROR');

// create employee by admin
const createEmployeeRequest = createAction('CREATE_EMPLOYEE_REQUEST', data => data);
const createEmployeeSuccess = createAction('CREATE_EMPLOYEE_SUCCESS', data => data);
const createEmployeeError = createAction('CREATE_EMPLOYEE_ERROR');


/* Get All Employee Action */
const getAllEmployeeRequest = createAction('GET_ALL_EMPLOYEE_REQUEST', data => data);
const getAllEmployeeSuccess = createAction('GET_ALL_EMPLOYEE_SUCCESS', data => data);
const getAllEmployeeError = createAction('GET_ALL_EMPLOYEE_ERROR');

/* Get All Employee Action */
const getUserOnRoleRequest = createAction('GET_USER_ON_ROLE_REQUEST', data => data);
const getUserOnRoleSuccess = createAction('GET_USER_ON_ROLE_SUCCESS', data => data);
const getUserOnRoleError = createAction('GET_USER_ON_ROLE_ERROR');


/* Get Profile Action */
const getProfileRequest = createAction('GET_PROFILE_REQUEST', data => data);
const getProfileSuccess = createAction('GET_PROFILE_SUCCESS', data => data);
const getProfileError = createAction('GET_PROFILE_ERROR');

/* aadhaar verify Action */
const aadhaarVerifyRequest = createAction('AADHAAR_VERIFY_REQUEST', data => data);
const aadhaarVerifySuccess = createAction('AADHAAR_VERIFY_SUCCESS', data => data);
const aadhaarVerifyError = createAction('AADHAAR_VERIFY_ERROR');

/* Get All Employee List Action */
const getAllEmployeeListRequest = createAction('GET_ALL_EMPLOYEE_LIST_REQUEST', data => data);
const getAllEmployeeListSuccess = createAction('GET_ALL_EMPLOYEE_LIST_SUCCESS', data => data);
const getAllEmployeeListError = createAction('GET_ALL_EMPLOYEE_LIST_ERROR');

/* Update Employee Details Action */
const updateEmployeeDetailsRequest = createAction('UPDATE_EMPLOYEE_DETAILS_REQUEST', data => data);
const updateEmployeeDetailsSuccess = createAction('UPDATE_EMPLOYEE_DETAILS_SUCCESS', data => data);
const updateEmployeeDetailsError = createAction('UPDATE_EMPLOYEE_DETAILS_ERROR');

/* bulk Upload Employee Action */
const bulkUpdateEmployeeRequest = createAction('BULK_UPLOAD_EMPLOYEE_REQUEST', data => data);
const bulkUpdateEmployeeSuccess = createAction('BULK_UPLOAD_EMPLOYEE_SUCCESS', data => data);
const bulkUpdateEmployeeError = createAction('BULK_UPLOAD_EMPLOYEE_ERROR');

/* bulk Upload Employee Action */
const resumeParserRequest = createAction('RESUME_PARSER_REQUEST', data => data);
const resumeParserSuccess = createAction('RESUME_PARSER_SUCCESS', data => data);
const resumeParserError = createAction('RESUME_PARSER_ERROR');

/* Generate employee id Action */
const generateEmployeeIdRequest = createAction('GENERATE_EMPLOYEE_ID_REQUEST', data => data);
const generateEmployeeIdSuccess = createAction('GENERATE_EMPLOYEE_ID_SUCCESS', data => data);
const generateEmployeeIdError = createAction('GENERATE_EMPLOYEE_ID_ERROR');

/* Generate employee id Action */
const getEmployeeByDepartmentRequest = createAction('GET_EMPLOYEE_BY_DEPARTMENT_REQUEST', data => data);
const getEmployeeByDepartmentSuccess = createAction('GET_EMPLOYEE_BY_DEPARTMENT_SUCCESS', data => data);
const getEmployeeByDepartmentError = createAction('GET_EMPLOYEE_BY_DEPARTMENT_ERROR');

/* Generate employee id Action */
const getEmployeeHistoryRequest = createAction('GET_EMPLOYEE_HISTORY_REQUEST', data => data);
const getEmployeeHistorySuccess = createAction('GET_EMPLOYEE_HISTORY_SUCCESS', data => data);
const getEmployeeHistoryError = createAction('GET_EMPLOYEE_HISTORY_ERROR');

/* Generate employee id Action */
const sendEmployeeCredentialsRequest = createAction('SEND_EMPLOYEE_CREDENTIALS_REQUEST', data => data);
const sendEmployeeCredentialsSuccess = createAction('SEND_EMPLOYEE_CREDENTIALS_SUCCESS', data => data);
const sendEmployeeCredentialsError = createAction('SEND_EMPLOYEE_CREDENTIALS_ERROR');

/* Generate employee id Action */
const uploadProfileRequest = createAction('UPLOAD_PROFILE_REQUEST', data => data);
const uploadProfileSuccess = createAction('UPLOAD_PROFILE_SUCCESS', data => data);
const uploadProfileError = createAction('UPLOAD_PROFILE_ERROR');

const employeeDetails = createAction('EMPLOYEE_DETAILS', data => data);
const selectedEmployeeData = createAction("SELECTED_EMPLOYEE", data => data)
const selectedCandidateData = createAction("SELECTED_CANDIDATE_DATA", data => data)

/* Clear Existing Employee Action */
const handleClearEmployeeStore = createAction('HANDLE_CLEAR_EMPLOYEE_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {

    getEmployeeForReportingManagerRequest,
    getEmployeeForReportingManagerSuccess,
    getEmployeeForReportingManagerError,

    getAllEmployeeRequest,
    getAllEmployeeSuccess,
    getAllEmployeeError,

    getUserOnRoleRequest,
    getUserOnRoleSuccess,
    getUserOnRoleError,

    getProfileRequest,
    getProfileSuccess,
    getProfileError,

    aadhaarVerifyRequest,
    aadhaarVerifySuccess,
    aadhaarVerifyError,

    createEmployeeRequest,
    createEmployeeSuccess,
    createEmployeeError,

    getAllEmployeeListRequest,
    getAllEmployeeListSuccess,
    getAllEmployeeListError,

    updateEmployeeDetailsRequest,
    updateEmployeeDetailsSuccess,
    updateEmployeeDetailsError,

    bulkUpdateEmployeeRequest,
    bulkUpdateEmployeeSuccess,
    bulkUpdateEmployeeError,

    resumeParserRequest,
    resumeParserSuccess,
    resumeParserError,

    generateEmployeeIdRequest,
    generateEmployeeIdSuccess,
    generateEmployeeIdError,

    getEmployeeByDepartmentRequest,
    getEmployeeByDepartmentSuccess,
    getEmployeeByDepartmentError,

    getEmployeeHistoryRequest,
    getEmployeeHistorySuccess,
    getEmployeeHistoryError,

    sendEmployeeCredentialsRequest,
    sendEmployeeCredentialsSuccess,
    sendEmployeeCredentialsError,

    uploadProfileRequest,
    uploadProfileSuccess,
    uploadProfileError,

    employeeDetails,
    selectedEmployeeData,
    selectedCandidateData,

    handleClearEmployeeStore,
}